// extracted by mini-css-extract-plugin
export default {"bg_start_page":"start-page_bg_start_page__o8V8m","mainImage":"start-page_mainImage__A2gmp"};